import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { useTranslate } from '@lumapps/translations';

import { INSTANCE_COPY } from '../../keys';
import { instancesCopy } from '../../routes';

const InstancesCopySideNavigation: React.FC<Partial<SideNavigationItemProps>> = (props) => {
    const { translateKey } = useTranslate();

    return <SideNavigationItem {...props} label={translateKey(INSTANCE_COPY.COPY)} route={instancesCopy()} />;
};

InstancesCopySideNavigation.displayName = 'SideNavigationItem';

export { InstancesCopySideNavigation };
